var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDollar24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.116 23c-.4 0-.731-.139-.993-.416a1.317 1.317 0 0 1-.392-.97v-1.361c-.893-.062-1.685-.2-2.378-.416-.677-.23-1.254-.469-1.731-.715-.431-.216-.7-.516-.808-.9-.108-.4-.092-.778.046-1.132.154-.37.4-.63.739-.785.354-.169.77-.138 1.246.093.37.2.885.407 1.547.623.662.2 1.47.3 2.424.3 1.062 0 1.816-.17 2.262-.508.447-.338.67-.762.67-1.27a1.34 1.34 0 0 0-.462-1.038c-.308-.277-.862-.5-1.662-.67l-2.54-.554c-2.8-.615-4.2-2.108-4.2-4.478 0-1.293.438-2.386 1.315-3.278.877-.893 2.055-1.455 3.532-1.686V2.385c0-.385.13-.708.392-.97.262-.276.593-.415.993-.415.385 0 .708.139.97.416.261.261.392.584.392.97V3.77a9.63 9.63 0 0 1 1.755.416 6.07 6.07 0 0 1 1.616.785c.369.23.592.53.669.9.092.354.061.692-.092 1.016a1.353 1.353 0 0 1-.762.692c-.339.123-.754.062-1.247-.184-.415-.2-.87-.37-1.362-.508-.492-.139-1.1-.208-1.823-.208-.893 0-1.593.185-2.101.554-.508.37-.762.846-.762 1.431 0 .416.146.762.439 1.039.307.262.838.477 1.592.646l2.563.554c1.462.324 2.54.855 3.232 1.593.708.724 1.062 1.655 1.062 2.794 0 1.308-.447 2.385-1.34 3.232-.877.846-2.023 1.392-3.439 1.639v1.454c0 .385-.13.708-.392.97a1.28 1.28 0 0 1-.97.415Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar24);
export default __webpack_public_path__ + "static/media/dollar_24.b101f2ad.svg";
export { ForwardRef as ReactComponent };